import { Injectable } from "@angular/core";
import { IVitalProfileDefinition } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class VitalProfileDefinitionApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "VitalProfileDefinition", // Theme !
      [], // Post route paths
      ["dashboard/vitalProfileDefinitions"], // Get route paths
      [], // Put route paths
      [] // Delete route paths
    );
  }

  public list(patientId: string, careplanRef?: string, filterHiddenVitalSign = false): Observable<IVitalProfileDefinition[]> {
    return this.api.get(this.readRoutes[0], { patient: patientId, careplanRef, filterHiddenVitalSign }) as Observable<
      IVitalProfileDefinition[]
    >;
  }
}
